import English from "@/Languages/en.json"
import Litva from "@/Languages/lt.json"

export const LANGUAGES = [
  {
    code: "en-US",
    label: "English",
    messages: English,
  },
  {
    code: "lt-LT",
    label: "Lithuania",
    messages: Litva,
  },
]
